import React, { useEffect } from 'react';
import './footer.css';
import insta from '../../assets/icons/insta.svg';
import x from '../../assets/icons/x.svg';
import yt from '../../assets/icons/yt.svg';
import fb from '../../assets/icons/fb.svg';
import FooterTitle from '../common/footerTitle';
import NavItem from '../common/navitem';
import { useTranslation } from 'react-i18next';

const Footer = () => {
        const { t, i18n } = useTranslation();

            useEffect(() => {
              const lang = i18n.language;
              const dir = lang === "ar" ? "rtl" : "ltr";
              document.documentElement.lang = lang;
              document.documentElement.dir = dir;
            }, [i18n.language]);
    
    return ( 
        <>
        <footer>
            <div className="footerCont">
                <div className="footerCol">
                    <span className='logo'>Spine</span>
                    <h6 className='body'>{t("Your gateway to literary experiences. Connecting readers, writers, and storytellers.")}</h6>
                    <div className="socials">
                        <img className='social' src={insta} alt="instagram icon" />
                        <img className='social' src={x} alt="twitter icon" />
                        <img className='social' src={yt} alt="youtube icon" />
                        <img className='social' src={fb} alt="facebook icon" />
                    </div>
                </div>
                <div className="footerCol">
                    <FooterTitle footerTitle={t("Quick Links")} />
                    <nav>
                        <ul>
                            <NavItem id="#home" navitem={t("Home")} />
                            <NavItem id="#listing" navitem={t("Listing")} />
                            <NavItem id="#upcoming" navitem={t("Upcoming")} />
                            <NavItem id="#featured" navitem={t("Featured")} />
                            <div className="display">
                                <NavItem id="#about" navitem={t("About")} />
                            </div>
                            <div className="display">
                                <NavItem id="#book" navitem={t("Book")} />
                            </div>
                            <div className="display">
                                <NavItem id="#reviews" navitem={t("Reviews")} />
                            </div>
                            <div className="display">
                                <NavItem id="#subscribe" navitem={t("Subscribe")} />
                            </div>
                        </ul>
                    </nav>
                </div>
                <div className="footerCol displayNone">
                    <FooterTitle footerTitle={t("Quick Links")} />
                    <nav>
                        <ul>
                            <NavItem id="#about" navitem={t("About")} />
                            <NavItem id="#book" navitem={t("Book")} />
                            <NavItem id="#reviews" navitem={t("Reviews")} />
                            <NavItem id="#subscribe" navitem={t("Subscribe")} />
                        </ul>
                    </nav>
                </div>
            </div>
            <div className="line"></div>
            <div className="copyrights">
                <p className='body'>{t("© 2026 Spine. All rights reserved.")}</p>
                <p className='body'>{t("Terms of Service   -  Privacy Policy")}</p>
            </div>
        </footer>
        </>
     );
}
 
export default Footer;